module.exports = __webpack_public_path__ + "static/media/leckey.6d2ef6e9.png";